function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { useNavigationList } from "@sprout/list-navigation";
import { useHistory } from "react-router-dom";
import TopicPageViewsLabelsLabel from "./TopicPageViewsLabelsLabel";
const SUPPORTED_ACTIONS = [
    "OPEN"
];
const TopicPageViewsLabelsLabels = (props)=>{
    const { labels , rootURL  } = props;
    const history = useHistory();
    const handleSingularAction = useCallback((command, activeItem)=>{
        if (!activeItem) return false;
        switch(command){
            case "OPEN":
                history.push(`${rootURL}/label/${activeItem.id}`);
                return true;
            default:
                return false;
        }
    }, [
        history,
        rootURL
    ]);
    const { Provider , navProps  } = useNavigationList("TopicPageViewsLabelsLabels", useMemo(()=>({
            actions: SUPPORTED_ACTIONS,
            performSingularAction: handleSingularAction
        }), [
        handleSingularAction
    ]));
    return /*#__PURE__*/ _jsx(Provider, {
        children: /*#__PURE__*/ _jsx("div", _objectSpread({}, navProps, {
            children: labels.map((label, index)=>{
                return /*#__PURE__*/ _jsx(TopicPageViewsLabelsLabel, {
                    index: index,
                    label: label,
                    to: `${rootURL}/label/${label.id}`
                }, label.id);
            })
        }))
    });
};
export default TopicPageViewsLabelsLabels;
